<!--
 * @Author: your name
 * @Date: 2021-06-15 15:22:26
 * @LastEditTime: 2021-07-02 11:11:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \e6-module-settle-accounts-center\src\e6-module-settle-accounts-center\views\report\components\upload.vue
-->
<template>
  <div class="img-upload">
    <div v-for="(img, idx) of urls" class="img-wrapper img-item" :key="img.id">
      <e6-image
        :src="img.src"
        class="avatar"
        title="查看附件"
        :preview-src-list="[img.src]"
      ></e6-image>
      <i
        v-if="!disabledDelUpload"
        @click="handleRemoveImage(idx)"
        class="e6-icon-delete_fill btn-cancle-img"
      ></i>
    </div>
    <div
      class="upload img-item"
      v-loading="loading"
      v-show="attachmentList.length < this.maxLength"
    >
      <el-upload
        class="avatar-uploader"
        name="files"
        accept=".jpg,.jpeg,.png,.bmp"
        :action="action"
        :before-upload="handleBeforeUpload"
        :headers="uploadHeaders"
        :on-success="handleSuccess"
        :on-error="handleError"
        :show-file-list="false"
      >
        <!-- // upload需要带的参数 -->
        <!-- :data="{
          customerId: 'e6yun',
          businessTypeKey: 'insurance',
          isReturnUrl: 1
        }" -->
        <div class="uploader-icon">
          <i class="el-icon-plus"></i>
        </div>
      </el-upload>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    attachmentList: {
      type: Array,
      default() {
        return [];
      }
    },
    maxLength: {
      type: Number,
      default: 5
    },
    // ****这里扩展需求【回单复审不能删除照片】****
    disabledDelUpload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      hasUploadError: false
    };
  },
  computed: {
    uploadHeaders() {
      return {
        token: Cookies.get("RequestToken")
      };
    },
    action() {
      return `${process.env.VUE_APP_HOST_API}/COMMON-MODULE-BASE-FILE-PROCESSOR-WEB/api/upload/fildUploadPublicByInputStream?customerId=e6yun3.0&businessTypeKey=waybillPlatform`;
    },
    urls() {
      return this.attachmentList.map((url, idx) => ({
        src: url,
        id: Math.random() + idx
      }));
    }
  },
  methods: {
    handleBeforeUpload(file) {
      const isJPG = file.type === "image/jpeg";
      // const isGIF = file.type === "image/gif";
      const isPNG = file.type === "image/png";
      const isBMP = file.type === "image/bmp";
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isJPG && !isPNG && !isBMP) {
        this.$message.info("上传图片必须是JPG/GIF/PNG/BMP 格式!");
        return false;
      }
      if (!isLt10M) {
        this.$message.info("上传图片大小不能超过 10MB!");
        return false;
      }
      if ((isJPG || isBMP || isPNG) && isLt10M) {
        this.loading = true;
        return true;
      } else {
        return false;
      }
    },
    handleSuccess(res) {
      let fileUrl = "";
      if (res.code === 1) {
        fileUrl =
          (Array.isArray(res.result) &&
            res.result[0] &&
            res.result[0].fileUrl) ||
          "";
      }
      if (fileUrl) {
        this.loading = false;
        // this.isRemove = true;
        this.$emit("add", fileUrl);
      }
    },
    handleError() {
      this.loading = false;
    },
    handleRemoveImage(idx) {
      this.$emit("minus", idx);
    }
  }
};
</script>

<style lang="scss" scoped>
.img-upload {
  display: flex;
  justify-content: flex-start;
  .img-item {
    position: relative;
    width: 108px;
    height: 90px;
    margin-right: 14px;
    .e6-image {
      width: 100%;
      height: 100%;
    }
    .btn-cancle-img {
      position: absolute;
      cursor: pointer;
      color: #f15656;
      right: -7px;
      top: -14px;
    }
    &.upload {
      box-sizing: border-box;
      border: 1px dashed #dcdfe6;
      border-radius: 8px;
      .avatar-uploader {
        height: 100%;
        position: relative;
        .uploader-icon {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          font-size: 50px;
          color: #dcdfe6;
        }
      }
    }
  }
}
</style>
